function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPricing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.5,1H5.5L0,9.49,12,23.25,24,9.49Zm-.76,1.25L22,8.75H18.32l-3.06-6.5Zm-4,0,3.05,6.5H7.21l3.06-6.5Zm-7.47,0H8.74L5.68,8.75H2.05Zm-3.85,8H5.9l3.63,8.17ZM12,20.56,7.42,10.25h9.15Zm2.47-2.15,3.63-8.16h3.49Z",
    style: {
      fill: "#3d7ef5"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricing);
export default __webpack_public_path__ + "static/media/pricing.bca149324360bba2aa6a25aedf5c973e.svg";
export { ForwardRef as ReactComponent };